import { render } from "./BlockExpensesTable.vue?vue&type=template&id=75d593d0"
import script from "./BlockExpensesTable.vue?vue&type=script&lang=js"
export * from "./BlockExpensesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__